import { localhostType, psychologistsSubDomains } from "screens/App/routes";

/**
 * True when the current hostname is the psychologists portal (psic*.team24.pt, or localhost with
 * `localhostType === "psychologists"` in routes.tsx). Same rule App/index.tsx, Sidebar and endpoints apply inline.
 */
export const isPsychologistsPortal = (): boolean => {
	const hostname = window.location.hostname?.split(".")?.[0];

	return (
		(hostname === "localhost" && (localhostType as string) === "psychologists") ||
		psychologistsSubDomains.includes(hostname)
	);
};
